import { useEffect } from 'react'

import { getToken } from 'firebase/messaging'
import { useSelector } from 'react-redux'

import { getMessagingInstance } from '../firebase'
import { postFCMToken } from '../api/postApi'

const VAPID_KEY = 'BJzJqSaLA66672G3hjgCQN1irlCFmRBNdJ4809iXKPZrXwAr8RSxyPP3aGuw_52wJfSWu7ZOtPvWLNJIsF3h87Y'

const useFCMToken = () => {
  const { isAuth } = useSelector(({ authentication }) => authentication)

  useEffect(() => {
    const getFCMToken = async () => {
      try {
        const messaging = await getMessagingInstance()
        if (!messaging) return

        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
        })

        if (token) await postFCMToken(token)
      } catch (error) {
        // console.error('FCM token error:', error)
      }
    }

    const requestPermission = async () => {
      if (!isAuth) return

      try {
        const permission = await Notification.requestPermission()

        if (permission === 'granted') await getFCMToken()
      } catch (error) {
        // console.error('Notification permission error:', error)
      }
    }

    requestPermission()
  }, [isAuth])
}

export default useFCMToken
